module.exports = __webpack_public_path__ + "static/media/servicio.8cfa22a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/eshopex/servicio.png
// module id = 1213
// module chunks = 0